import React from "react";

export default function MyCrm() {
  return (
    <div>
      <div className="balanceBox">
        <div className="balanceBoxInner bg-light">
          <h2 className="balanceBoxTitle text-center text-dark">MyCrm</h2>
        </div>
      </div>
    </div>
  );
}
